// DrawerButton.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './DrawerButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * DrawerButton
 *
 * Opens or closes the mobile sidebar drawer.
 *
 * @param {boolean} isOpen - Whether the drawer is open.
 * @param {Function} setIsOpen - Setter for open state.
 * @param {boolean} [inline=false] - When true, sits in document flow (top bar).
 * @returns {ReactNode}
 */
const DrawerButton = React.memo(({ isOpen, setIsOpen, inline = false }) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (

        <button
          className={[
            'drawer-button-container',
            inline ? 'is-inline' : '',
          ].filter(Boolean).join(' ')}
          type="button"
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isOpen}
          aria-controls="main-mobile-drawer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
            <Icon
              iconKey="dehaze"
              width={26}
              height={26}
              color={theme.foreground}
            />

        </button>
    );

});

// Dev Tools
DrawerButton.displayName = 'DrawerButton';

export default DrawerButton;
